import { Middleware } from "@reduxjs/toolkit";
import { setClsMiddlewareApplicationLog } from "../../services/log/logOptions";
import { infraApi } from "../api/infrastructureApi";
import { requestLogMapper } from "./mappers/requestLogMapper";
import { responseLogMapper } from "./mappers/responseLogMapper";
import store from "../stores/store";
import { addFulfilledLog } from "../slices/logSlice";
import { isFulfilledCustomMetaAction } from "../../services/api/rtkTypeGuardChecks";

export const fulfilledRequestLoggerMiddleware: Middleware = () => (next) => (action) => {
  if (isFulfilledCustomMetaAction(action)) {
    const actionMeta = action.meta;
    const endpointName = actionMeta.arg.endpointName;
    const logEndpointName = infraApi.endpoints.addLogData.name;
    const isLogRequest = endpointName === logEndpointName;

    //To avoid looping when sending logs to the service
    if (isLogRequest) {
      return next(action);
    }

    const { request, response } = actionMeta.baseQueryMeta || {};
    const mappedRequest = request ? requestLogMapper(request) : undefined;
    const mappedResponse = response ? responseLogMapper(response) : undefined;

    store.dispatch(
      addFulfilledLog({
        endpointName: action?.meta?.arg?.endpointName,
        clsLog: setClsMiddlewareApplicationLog({
          requestId: action.meta.requestId,
          request: mappedRequest,
          response: mappedResponse,
        }),
      })
    );
  }
  return next(action);
};
